import React from 'react';

const Arrow = () => (
    <div className="has-text-centered">
        <svg className="arrows">
            <path className="a1" d="M0 10 L30 32 L60 10"></path>
            <path className="a2" d="M0 25 L30 47 L60 25"></path>
            <path className="a3" d="M0 40 L30 61 L60 40"></path>
        </svg>
    </div>
)

export default Arrow;